import { render, staticRenderFns } from "./FullTargetCustom.vue?vue&type=template&id=1db23a43"
import script from "./FullTargetCustom.vue?vue&type=script&lang=js"
export * from "./FullTargetCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports